import { Component } from '@angular/core';
import {NavController, NavParams, ViewController,ToastController} from 'ionic-angular';
import * as moment from 'moment';
import {RequestsExecutionProvider} from "../../../../providers/requests-execution/requests-execution";
import {Params} from "../../../params";
import * as firebase from 'firebase/app';

@Component({
  selector: 'page-action',
  templateUrl: 'action.html',
})
export class ActionRequestsPage {
  view = {
    title : "",
    color : "primary",
    button : "Aceptar"
  };
  saturdays = []
  action : string = "";
  request;
  types;
  statuses;
  foods;
  plans;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    private toastCtrl : ToastController,
    private execute : RequestsExecutionProvider) {

    this.action = this.navParams.get('action');
    this.request = this.navParams.get('request');
    this.types = this.navParams.get('types');
    this.statuses = this.navParams.get('statuses');
    this.foods = this.navParams.get('foods');
    this.plans = this.navParams.get('plans');

    if(this.action=="approve") this.view = { title: "Aprobar solicitud para "+this.request.customerName, color : "primary",button:"Aprobar"}
    if(this.action=="decline") this.view = { title: "Rechazar solicitud para "+this.request.customerName, color : "danger",button:"Rechazar"}
    if(this.action=="more") this.view = { title: "Viendo solicitud", color : "light",button:"Cancelar"}

    const dayINeed = 6; // for Saturday
    const today = moment().isoWeekday();
    let first_saturday;
    if (today <= dayINeed) {
      first_saturday = moment().isoWeekday(dayINeed);
    } else {
      first_saturday = moment().add(1, 'weeks').isoWeekday(dayINeed);
    }
    this.saturdays.push({
      date : first_saturday.toISOString(),
      format : first_saturday.format("dddd DD MMMM")
    })
    for(let i=1;i<5;i++){
      let temp = moment(first_saturday).add(i,'weeks');
      this.saturdays.push({
        date : temp.toISOString(),
        format : temp.format("dddd DD MMMM")
      })
    }
  }

  ok(){
    if(this.action=="more"){
      this.viewCtrl.dismiss();
    }

    if(this.action=="decline"){
      let update = {
        status : 2,
        obs_decline : this.request.obs_decline,
        execution : {
          date : moment().toISOString(),
          proccesed: false,
        }
      }
      console.log('/requests/'+this.request.date+'/'+this.request.customerid+'/'+this.request.requestid);
      firebase.database().ref('/requests/'+this.request.date+'/'+this.request.customerid+'/'+this.request.requestid)
        .update(update).then(()=>{
        let toast = this.toastCtrl.create({
          message: "Solicitud rechazada exitosamente",
          duration: 3000
        });
        toast.present();
        this.viewCtrl.dismiss();
      })
    }

    if(this.action=="approve"){
      // this.requestRef = this.af.object('/requests/'+this.request.date+'/'+this.request.customerid+'/'+this.request.requestid);
      this.request.execution.date = moment().toISOString();
      if(this.request.execution.type=='now'){
        this.execute.process(this.request).then(()=>{
          let update = {
            status : 1,
            execution : {
              type : this.request.execution.type,
              date : this.request.execution.date,
              proccesed: true,
              owner : Params.md5(Params.USER_DATA.email)
            },
            obs_approve : this.request.obs_approve
          }
          firebase.database().ref('/requests/'+this.request.date+'/'+this.request.customerid+'/'+this.request.requestid)
            .update(update).then(()=>{
            let toast = this.toastCtrl.create({
              message: "Solicitud aprobada y processada exitosamente",
              duration: 3000
            });
            toast.present();
            this.viewCtrl.dismiss();
          })
        }).catch(()=>{
          alert('No se pudo procesar');
        })

      }else{
        let update = {
          status : 1,
          execution : {
            type : this.request.execution.type,
            date : this.request.execution.date,
            proccesed: false,
          },
          obs_approve : this.request.obs_approve
        }
        firebase.database().ref('/requests/'+this.request.date+'/'+this.request.customerid+'/'+this.request.requestid)
          .update(update).then(()=>{
          let toast = this.toastCtrl.create({
            message: "Solicitud aprobada exitosamente",
            duration: 3000
          });
          toast.present();
          this.viewCtrl.dismiss();
        });
      }

    }
  }

  format(date,hour) {
    if(hour){
      return moment(date).format("DD MMMM YY HH:mm:ss");
    }else{
      return moment(date).format("DD MMMM YY");
    }

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ActionPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/changes/requests/action/action.ts